import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import BackgroundImage from "../../components/ui/BackgroundImage";
import bg from "./assets/images/bg.webp";
import PanelHeader from "./components/PanelHeader";
import CarPanel from "./components/car-panel/CarPanel";
import CarRadio from "./components/car-radio/CarRadio";
import { PanelScreenType } from "./panel.types";
import blueLeftCircle from "./assets/images/blue-circle.webp";
import redRightCircle from "./assets/images/red-circle.webp";

interface CarPanelRenderProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function CarPanelRender({ isOpen, onClose }: CarPanelRenderProps) {
  const [activeScreen, setActiveScreen] = useState<PanelScreenType>("panel");

  return (
    <BackgroundImage imageSrc={bg} imageClassName="!object-fill">
      <div className="h-screen w-full flex items-center justify-center purista-font">
        <AnimatePresence>
          {isOpen && (
            <motion.section
              className="p-6 rounded-3xl bg-gradient-to-r from-[#0a0d0e]/90 via-[#0f0e0e]/90 to-[#0d0d0d]/90 w-[960px] max-h-[75%] relative overflow-hidden z-[1] flex flex-col"
              initial={{ opacity: 0, y: -16 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -16 }}
              transition={{ duration: 0.22, ease: "easeOut" }}
            >
              <PanelHeader
                onClose={onClose}
                activeScreen={activeScreen}
                onScreenChange={setActiveScreen}
                title={activeScreen === "panel" ? "CAR PANEL" : "CAR RADIO"}
                description="Here you can manage your car"
              />
              <main className="flex-1 min-h-0 flex flex-col overflow-hidden">
                {activeScreen === "panel" ? <CarPanel /> : <CarRadio />}
              </main>

              <div
                className="absolute top-0 left-0 right-0 flex items-center justify-between z-[-1]"
                draggable={false}
              >
                <img
                  src={blueLeftCircle}
                  alt=""
                  draggable={false}
                  className="select-none"
                />
                <img
                  src={redRightCircle}
                  alt=""
                  draggable={false}
                  className="select-none"
                />
              </div>
            </motion.section>
          )}
        </AnimatePresence>
      </div>
    </BackgroundImage>
  );
}
